import { Component, Input } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExtendedFormGroup } from '../../../base-classes/extended-form-group.class';
import { ControlBase } from '../../base/control-base/control-base.component';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
declare var $: any;

@Component({
    selector: 'summernote-textbox-extended-control',
    templateUrl: './summernote-textbox-extended.control.html',
    standalone: false,
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class SummernoteTextboxExtendedControl extends ControlBase {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
    }

    @Input() parentForm: ExtendedFormGroup<any>;
    @Input() controlName: string;

    @Input() parentFormHelper!: {
        showFieldError(controlName: string): boolean;
        getErrorMessageHtml(controlName: string): string;
    };

    public ngAfterViewInit(): void {
        this.initSummerNote();
    }

    private initSummerNote() {
        $('#summernote').summernote({
            height: 250,
            tooltip: true,
            tabsize: 2,
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['insert', ['link', 'picture', 'video', 'table']],
                ['view', ['codeview', 'help']],
            ],
            callbacks: {
                onChange: (contents: string) => {
                    this.parentForm.controls[this.controlName].setValue(this.cleanHtml(contents));
                },
                onBlurCodeview: () => {
                    let codeContents = $('#summernote').summernote('code');
                    this.parentForm.controls[this.controlName].setValue(this.cleanHtml(codeContents));
                },
            },
        });
    }

    private cleanHtml(bodyValue: string): string {
        let cleanedBodyValue = bodyValue
            .replace(/\n+/g, '')
            .replace(/\r+/g, '')
            .replace(/\s{2,}/g, ' ')
            .trim();

        return cleanedBodyValue;
    }
}
